// extracted by mini-css-extract-plugin
export default {"course-details-container":"CourseDetails_course-details-container__Szxhl","course-details":"CourseDetails_course-details__og8-i","applybtn":"CourseDetails_applybtn__0bGcY"};